import { formatPrecisaoFloat } from "./format-precisao-float";

const formatPrice = (valor, cifra = true) => {
  const valorTruncado = formatPrecisaoFloat(valor || 0);
  return cifra
    ? valorTruncado.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      })
    : valorTruncado.toLocaleString("pt-br", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
};

export default formatPrice;
